import PatientProfileForm from './PatientProfileForm';

export default PatientProfileForm;



// WEBPACK FOOTER //
// ./src/views/components/PatientProfileForm/index.js